export default __webpack_public_path__ + "static/media/google-play.fc3467fb.svg";